import SEO from "@/components/SEO";
import CTASection from "@/components/CTASection";
import { TECHNOLOGIES } from "@/data/content";

export default function Technologies() {
  const groups = Array.from(new Set(TECHNOLOGIES.map((t) => t.group)));

  return (
    <>
      <SEO title="Technologies" description="The database, cloud, analytics and data engineering technologies DataMeridian consultants specialise in." />

      <section className="bg-[var(--dm-navy)] text-white">
        <div className="dm-container py-24 lg:py-32">
          <div className="dm-overline text-[var(--dm-emerald)]">Technologies</div>
          <h1 className="font-serif text-5xl sm:text-6xl mt-6 max-w-4xl leading-[1.05]">The technologies our engineers have shipped in production.</h1>
          <p className="text-white/70 text-lg mt-8 max-w-2xl">Not a shopping list — a working stack. Every technology below is one our consultants have operated in production for enterprise clients.</p>
        </div>
      </section>

      <section className="bg-white">
        <div className="dm-container dm-section space-y-16">
          {groups.map((g) => (
            <div key={g}>
              <div className="dm-overline">{g}</div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--dm-border)] mt-6">
                {TECHNOLOGIES.filter((t) => t.group === g).map((t) => (
                  <div key={t.name} data-testid={`tech-${t.name}`} className="bg-white p-6 hover:bg-[var(--dm-surface)] transition-colors">
                    <div className="font-serif text-lg text-[var(--dm-navy)]">{t.name}</div>
                    <div className="text-xs font-mono text-[var(--dm-emerald)] mt-2 uppercase tracking-[0.18em]">{t.group}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTASection />
    </>
  );
}
